
import DepthTitle, { toggleDepth } from "./DepthTitle";

const OptionListContainer = (depthNo) => {
  const container = document.createElement('ul');
  container.classList.add('purchase_selector');
  container.setAttribute('data-depth', depthNo);
  return container;
};

const CalendarContainer = () => {
  const container = document.createElement('div');
  container.classList.add('calendar_wrap');
  container.setAttribute('data-role', 'prchCalendarWrap');
  return container;
};

const OptionList = (depthNo) => {
  const { nCalendarDepth } = TMON.oApp.htStorage.optionInfo;
  const isCalendar = nCalendarDepth === depthNo;

  if (isCalendar) return CalendarContainer();
  return OptionListContainer(depthNo);
};

const Container = (depthNo, disabled, title) => {
  const { nCalendarDepth } = TMON.oApp.htStorage.optionInfo;
  const isCalendar = nCalendarDepth === depthNo;

  const container = document.createElement('div');
  container.classList.add('dep-sel');
  container.classList.add(`dep${depthNo}`);
  if (isCalendar) container.classList.add(`dep-calendar`);
  container.setAttribute('data-role', 'prchDepSelWrap');
  container.setAttribute('data-name', `prchDepSelWrap${depthNo}`);
  container.append(
    DepthTitle(depthNo, disabled, title),
    OptionList(depthNo),
  );
  return container;
};

function isChangable(depthNo, depthTotal) {
  const { htStaticData, purchaseOption } = TMON.oApp.htStorage;
  const { bOptionDeal, bDetailviewAvailable, isChangeableOption } = htStaticData;

  // 옵션 딜 + 상세보기 가능 + depth 2개 이상
  if (bOptionDeal && bDetailviewAvailable && depthTotal > 1) {
    if (isChangeableOption) return true; // 예외 참고: [ABTest][DECE-2228]
    return depthNo === depthTotal - 1; // 현재 depth가 마지막이면 변경 가능
  }

  // 선택한 옵션이 있으면 옵션을 선택하지 않은 depth 부터 변경 가능
  if (purchaseOption && purchaseOption.nCurrentDepth) {
    return purchaseOption.nCurrentDepth + 1 >= depthNo;
  }

  // 첫 depth의 옵션만 선택 가능
  return depthNo === 0;
}

const OptionListHTML = optionTitles => {
  const depthTotal = optionTitles.length;
  return optionTitles.map((title, depthNo) => {
    const disabled = !isChangable(depthNo, depthTotal);
    return Container(depthNo, disabled, title).outerHTML;
  }).join('');
};

export default OptionListHTML;

/**
 * 선택한 depth 옵션에 따른 업데이트
 * 선택한 depth -> depth 제목을 선택한 옵션으로 변경
 * 다음 depth -> depth 제목 기본으로 변경, 옵션 목록 업데이트
 * 마지막 depth까지 -> depth 제목 기본으로 변경, 옵션 목록 지우기
 * 
 * 함수 호출 케이스
 * 1. depth 옵션 선택(p, m) - p는 모두, m은 1번 컨테이너
 * 2. 옵션 상세 팝업에서 하단 구매하기 버튼 클릭 시(m) - 1번 컨테이너
 * 3. 옵션 상세 팝업에서 상단 옵션 선택 버튼 클릭 시(p) - 2번 컨테이너
 * 4. n depth 옵션 상세 팝업에서 슬라이드 변경 시(p, m) - p는 2번, m은 1번 컨테이너
 * 5. 딜 상세 페이지 옵션 목록에서 각 옵션 하단에 옵션 선택 버튼 클릭 시(m) - 1번 컨테이너
 */
export function updateAll() {
  const { purchaseOption, optionInfo } = TMON.oApp.htStorage;
  const { nCurrentDepth, allDepthContainer, aKeyList } = purchaseOption;
  const { titles, nCalendarDepth, totalDepth, options } = optionInfo;

  const getDepthPair = depthNo => {
    return [ ...document.querySelectorAll(`div[data-name="prchDepSelWrap${depthNo}"]`) ];
  }

  const getTitle = depthNo => {
    const rawTitle = titles[depthNo];
    return typeof rawTitle === 'string' ? rawTitle : `옵션명${nNum}`;
  }

  function getAllDepthContainer() {
    const containerList = document.querySelectorAll('div[data-role="prchSelector"]');
    if (TMON.sDevice !== 'PW') return containerList[0];
    if (!allDepthContainer) return containerList[1];
    
    if (nCurrentDepth === nCalendarDepth) {
      return allDepthContainer.parentElement.parentElement;
    }

    return allDepthContainer;
  }

  const updateSelected = depthNo => {
    const selectedOptionKey = aKeyList[nCurrentDepth];
    let title = '';
    let isBundleOnlyOption = false;
    if (depthNo === totalDepth - 1) {
      const { data } = TMON.oApp.htStorage.optionList;
      const { isBundleOnly, optionTitle } = data.find((el) => el.optionNo === +selectedOptionKey);
      isBundleOnlyOption = isBundleOnly;
      title = optionTitle;
    } else { 
      title = options[nCurrentDepth].find((el) => {
        return el.key === selectedOptionKey;
      }).value;
    }
    getDepthPair(depthNo).forEach(depth => {
      const button = depth.children[0];
      button.textContent = title.split('|').pop();
      if (isBundleOnlyOption) {
        const strong = document.createElement('strong');
        strong.classList.add('addoption');
        strong.textContent = '[추가구매상품] ';
        button.prepend(strong);
      }
    });
    if (depthNo === totalDepth - 1) {
      toggleDepth(depthNo, getAllDepthContainer(), false);
    }
  };

  const updateNext = depthNo => {
    const title = getTitle(depthNo);
    getDepthPair(depthNo).forEach(depth => {
      const button = depth.children[0];
      button.removeAttribute('disabled');
      button.textContent = title;
    });
    
    toggleDepth(depthNo, getAllDepthContainer(), true);
  };

  const reset = depthNo => {
    const title = getTitle(depthNo);
    getDepthPair(depthNo).forEach(depth => {
      const button = depth.children[0];
      const optionListContainer = depth.children[1];
      optionListContainer.innerHTML = '';

      button.setAttribute('disabled', 'disabled');
      button.textContent = title;
    });
  };

  titles.forEach((_, index) => {
    if (index === nCurrentDepth) updateSelected(index);
    else if (index === nCurrentDepth + 1) updateNext(index);
    else if (index > nCurrentDepth + 1) reset(index);
  });
}
